import { takeLatest, call, put } from 'redux-saga/effects'

import I18n from 'i18n'
import * as fromActions from 'store/actions/evaluation-questions.action'
import * as fromNormalQuestionAction from 'store/actions/questions.action'
import { editLikertQuestion } from 'api/administration/questions/Edit'
import { getQuestionList } from 'api/administration/questions/List'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import { QuestionOptionForm } from 'models/question.model'
import { BlockTypes } from 'enum/block-type.enum'
import { IQuestionLikertModel } from 'models/questionLikert.model'
import { ActionWithPayload } from 'helpers/redux-actions.helper'

const pattern = fromActions.EVALUATION_QUESTION_LIKERT_EDIT

async function getList(instanceId: number) {
  return getQuestionList(instanceId)
}

async function handleEditLicker(data: any, questionId: number) {
  return editLikertQuestion(data, questionId)
}

function* editLikertEffectSaga(
  action: ActionWithPayload<
    typeof pattern,
    fromActions.QuestionLikertEditPayload
  >
) {
  try {
    const {
      payload: {
        questionId,
        id,
        instanceId,
        questionData: {
          text,
          order,
          link: { url, type },
          options,
          explanationAnswer,
        },
      },
    } = action
    const aux: IQuestionLikertModel<BlockTypes.BlockEvaluation> = {
      likert: {
        likertLabelsAttributes:
          options?.map(
            (
              { id, text, checked, _destroy = false }: QuestionOptionForm,
              index: number
            ) => {
              const auxData = { label: text, order: index, checked, _destroy }
              return id ? { ...auxData, id } : auxData
            }
          ) || [],
      },
      question: {
        name: text,
        description: '',
        mandatory: true,
        order,
        blockInstanceableId: id,
        blockInstanceableType: BlockTypes.BlockEvaluation,
        url,
        urlType: type,
        explanationAnswer,
      },
    }
    yield call(handleEditLicker, aux, questionId)
    const questionList = yield call(getList, instanceId)
    yield put(
      fromNormalQuestionAction.Actions.questionsListSuccess(questionList)
    )
    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    yield put(fromNormalQuestionAction.Actions.setQuestionLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editEvaluationLikertWatcherSaga() {
  yield takeLatest(pattern, editLikertEffectSaga)
}
